import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';

const ProcessAutomation = () => {
  return (
    <>
      <SEO 
        title="Process Automation Services - Abacies Logiciels"
        description="Automate repetitive business processes with intelligent automation solutions. Reduce manual effort, improve accuracy, and increase efficiency with Abacies' process automation services powered by AI and RPA."
        keywords="process automation, business process automation, RPA, robotic process automation, workflow automation, intelligent automation"
      />

      <section className="hero-section">
        <div className="page-container">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 text-charcoal animate-fade-in">
              Process Automation
            </h1>
            <p className="text-xl text-titanium leading-relaxed animate-slide-up">
              This is the Process Automation page with sample content.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 md:py-20 bg-white">
        <div className="page-container">
          <div className="max-w-4xl mx-auto">
            <p className="text-titanium mb-6">
              Sample content for Process Automation. This page contains placeholder text and will be updated with actual content.
            </p>
            <Link to="/" className="btn-primary">Return Home</Link>
          </div>
        </div>
      </section>
    </>
  );
};

export default ProcessAutomation;
